import React from 'react';
import { css } from 'aphrodite/no-important';
import { Link } from '../../../partials/link/Link';
import { CardComponentDataProps } from '../../../partials/cards/cards.utils';
import { AnalyticsEventParams } from '../SuggestedPosts';
import { H4 } from '../../../../typography/semanticTags';

interface ArticleLineProps {
    index: number;
    article: CardComponentDataProps;
    suggestedPostsAnalytics: (linkNumber: number, linkUrl: string) => () => void;
    analyticsEventParams: AnalyticsEventParams;
    styles: { [key: string]: any };
}

export const ArticleLine = (props: ArticleLineProps) => {
  const { index, article, suggestedPostsAnalytics, analyticsEventParams, styles } = props;

  return (
    <div className={css(styles.articleWrapper)} key={`article ${index}`}>
      <div className={css(styles.circle)}>&bull;</div>
      <Link
        href={article.articleUrl}
        onClick={suggestedPostsAnalytics(index + 1, article.articleUrl)}
        data-vars-action={analyticsEventParams.action}
        data-vars-category={analyticsEventParams.category}
        data-vars-label={analyticsEventParams.label}
      >
        <H4 styles={[styles.articleItem]}>
          {article.title}
        </H4>
      </Link>
    </div>
  );
};
